module.exports = __webpack_public_path__ + "static/setupimg-ac0e58510eacb364479c09e42eb162bd.jpg";